
import { HttpRequestBuilder } from "utils/http";
import * as tslib from "tslib";

const _httpTemps: { [key: string]: HttpRequestBuilder } = {};
const _dataCaches: { [key: string]: JQueryXHR  } = {};
export class xhrCache {
    constructor(public key, public getHttpBuilder) { }

    /**
     * ֹͣ��ǰ����
     */
    stop() {
        if (_httpTemps[this.key]) {
            _httpTemps[this.key].stop();
        }
        return this;
    }
    
    /**
     * ɾ������
     * @param cache_id
     */
    removeCache(cache_id){
        delete _dataCaches[cache_id];
        return this;
    }    
    /**
     * ��������
     * @param dataAction
     */
    async data(dataAction: (_http: HttpRequestBuilder) => any) {
        _httpTemps[this.key] = this.getHttpBuilder();
        var data = await dataAction(_httpTemps[this.key]);
        delete _httpTemps[this.key];
        return data;
    }
    /**
     * ���󲢻�������
     * @param cache_id
     * @param getRequest
     * @param timeout
     */
    public async cache(cache_id, getRequest,timeout=0) {
        if (!_dataCaches[cache_id]) {
            _httpTemps[this.key] = this.getHttpBuilder();
            _dataCaches[cache_id] = getRequest(_httpTemps[this.key]);
        }
        try {
            let data = await _dataCaches[cache_id];
            _dataCaches[cache_id] = data;

            if (timeout > 0) {
                setTimeout(() => {
                    delete _dataCaches[cache_id];
                }, timeout);
            }

            return data;
        }
        catch (ex) {
            delete _dataCaches[cache_id];
        }
        finally {
            delete _httpTemps[this.key];
        }
    }

    /**
     * ��ȡ����ʵ��
     * @param key
     * @param httpFactory
     */
    static get(key, getHttpBuilder) {
        return new xhrCache(key, getHttpBuilder);
    }
}


// WEBPACK FOOTER //
// ./src/utils/cache.ts